import React from "react";
import { useDispatch } from "react-redux";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { deleteUserPassport } from "Bands/state";

const { userPassport: passportCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserPassportModal: React.FC<Props> = ({
  id,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserPassport(id));
  };

  return (
    <DeleteUserEntityModal
      type="passport"
      action={USER_ACTIONS.deleteUserPassport}
      successMessage={passportCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
